import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=ee7f2b0e"
import script from "./terms-and-conditions.ts?vue&type=script&lang=ts&external"
export * from "./terms-and-conditions.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports